import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import axios from "axios";
import ToastModal from "views/components/ToastModal";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { headerLabel } from "assets/properties/properties";
import { useNavigate, useOutletContext } from "react-router-dom";
import { loanApplicationStatusNamesList } from "assets/properties/properties";
import { checkForRepledgeAccount } from "utils/Utils";
import { APPLICATION_TYPE_RE_PLEDGE } from "assets/properties/properties";

const ESignPartB = ({ setNext, setBack, loanApplicationId, classes, isEsign, alreadyEsigned, setAlreadyEsigned, closeModal,esingDisable, setEsignDisable, featureFlags,loanType, prePledgeLoan  }) => {
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('')
  const [preview, setPreView] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [message, setMessage]= useState('');
    const outletData = featureFlags;
    const parseAndSetFlag = (flag) => {
      return typeof flag === "boolean" ? flag : flag === "true";
    };
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const [hideAffidavit, setHideAffidavit] = useState(false);
  const [esignLetterState , setEsignLetterState] = useState(false);
  useEffect(() => {
    getFeatureFlag();
  }, []);
  const navigate=useNavigate();
  
  const getFeatureFlag = async () => {
    const result = await apiHandler({
      url: endpoint.FEATURE_FLAG,
      method: "GET",
      authToken: authToken,
    });
    setHideAffidavit(parseAndSetFlag(result?.data?.hideAffidavitTabFlag));
  };
  useEffect(() => {
    if(isEsign && !esingDisable){
      const interval = setInterval(async () => {
        const res = await apiHandler({
          url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-b",
          method: "GET",
          authToken: authToken,
        });
        setCallInProgress(false);
        if (res?.data?.status === "DONE" && res?.data?.fileLink) {
         
          GetPreviewLink(res?.data?.fileLink)
          clearInterval(interval);
          setEsignDisable(false)
        } else if(res?.data?.status === "REJECTED"){
          setMessage("Your Sanction Letter is Rejected. Please Esign Again");
          setEsignDisable(false)
        }
      },10000);
      return () => {
        clearInterval(interval);
      };
    }else{
      GetSanctionLetter();
    }
  }, []);
  const handleNext = () => {
    setNext();
  };
  const handleBack = () => {
    setBack();
  };

  const GetSanctionLetter = async () => {
    //SANCTION_LETTER
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_DOUMENTS + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.sanctionLetterPartBLink || res?.data?.esignSanctionLetterPartB) {
      const selectedLetter = res?.data?.esignSanctionLetterPartB ? res?.data?.esignSanctionLetterPartB : res?.data?.sanctionLetterPartBLink
      setPreView(selectedLetter);
    }else{
      GetEsignSanctionLetter();
    }

  };
  const GetEsignSanctionLetter = async()=>{
    if(!esignLetterState){  
      const interval = setInterval(async () => {
      const res = await apiHandler({
        url: endpoint.ESIGN_SANCTION_LETTER + loanApplicationId + "/part-a",
        method: "GET",
        authToken: authToken,
      });
      setCallInProgress(false);
      if (res?.data?.status === "DONE" && res?.data?.fileLink) {
        GetPreviewLink(res?.data?.fileLink)
        clearInterval(interval);
        setEsignLetterState(true)
      } else if(res?.data?.status === "REJECTED"){
        setMessage("Your Sanction Letter is Rejected. Please Esign Again");
        setEsignLetterState(true)
      }
    },10000);
    return () => {
      clearInterval(interval);
    };
  }
  }
  const GetPreviewLink = async (letterLink) =>{
    setPreView(letterLink);
  }
  const onClickProceedData = async () => {
    setCallInProgress(true);
    if (loanType === APPLICATION_TYPE_RE_PLEDGE) {
         const checkResult = await checkForRepledgeAccount(authToken, prePledgeLoan);
         if(checkResult?.data?.error_code){
          toastUpdate("Error",checkResult?.data?.user_description,true);
          return;
        }else{
           const filteredData = checkResult?.data?.filter(item => Number(item?.id) !== Number(loanApplicationId)) || [];
           if (Array.isArray(filteredData) && filteredData.length > 0) {
          const ids = filteredData
            .map(item => item?.id)
            .filter(Boolean);
          const idsText = ids.length > 0 ? ` Lead Ids: ${ids.join(", ")}` : "";
          toastUpdate(
            "Error",
            `Already Repledge Loan Present with ${idsText}`,
            true
          );
          return false;
        }
        }
     }
    const result = await apiHandler({
    url: endpoint.DISBURSAL_APPLICATION_LMS + loanApplicationId + `?newDisbursement=true`,
      method: "POST",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
        navigate("/loanservice/disbursLms", { state: { from: '' } });
    }
  };
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "start" }}>
           <SubHeader
                           label={headerLabel?.esignPartB}
                           subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
                           onlyLabel/>
        </GridItem>
      </GridContainer>
      
      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          {preview || !isEsign || alreadyEsigned ? <iframe src={preview} width="100%" height="500px" />
          :
          <GridItem
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            textAlign: "center",
            marginTop: 50,
          }}
        >
          <h4>
            Document Send for signing. Please authorize yourself
            in another Tab and come back.
          </h4>
          <br />
          <CircularProgresss />
          <br />
          <h6>Do Not refresh this screen.</h6>
        </GridItem>
        }
        </GridItem>
      </GridContainer>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12} lg={12} style={{ textAlign: "end" }}>
          <Button
            size="small"
            className={classes.nextButton1}
            disabled={callInProgress}
            onClick={() => handleBack()}
          >
            Back
          </Button>
          <Button
            size="small"
            className={classes.nextButton}
            disabled={callInProgress}
            onClick={() => hideAffidavit ? onClickProceedData() : handleNext()}
          >
            {hideAffidavit ? "Submit" : "Next" }
          </Button>
        </GridItem>
      </GridContainer>
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
    </div>
  );
};

ESignPartB.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  closeModal: PropTypes.func,
};

export default ESignPartB;
